// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDRY0NDS-bp4c0sT9g8GzODV8XLqFS4V-4",
  authDomain: "gowri-prasanna.firebaseapp.com",
  databaseURL: "https://gowri-prasanna-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "gowri-prasanna",
  storageBucket: "gowri-prasanna.appspot.com",
  messagingSenderId: "367138857943",
  appId: "1:367138857943:web:934d90131b70968eed2192"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const storage =  getStorage(app);

export const auth = getAuth(app);